/* SSi website – Portuguese landing page hero. Mirrors SpanishHero.jsx — same A/B variants. */
import { Link } from 'react-router-dom';

export function PortugueseHero({ onStart, t }) {
  const variant = t.ptHeroVariant || 'A';
  return variant === 'B'
    ? <PortugueseHeroB onStart={onStart} t={t}/>
    : <PortugueseHeroA onStart={onStart} t={t}/>;
}

function PortugueseHeroA({ onStart, t }) {
  return (
    <section className="ssi-ptHero ssi-ptHero--A" style={ptHeroStyles.wrapA}>
      <div className="ssi-ptHero__leftA" style={ptHeroStyles.leftA}>
        {t.ptHeroKicker && <div style={ptHeroStyles.kicker}>{t.ptHeroKicker}</div>}
        <h1 style={ptHeroStyles.h1}>{t.ptHeroTitle}</h1>
        <p style={ptHeroStyles.lede}>{t.ptHeroSub1}</p>
        <p style={ptHeroStyles.lede}>{t.ptHeroSub2}</p>
        <div style={ptHeroStyles.ctas}>
          <Link to="/pay?course=en-pt" className="btn btn--onDark">{t.ptHeroCta1}</Link>
          <a href="#sample" className="btn" style={ptHeroStyles.ghost}>{t.ptHeroCta2}</a>
        </div>
        <p style={ptHeroStyles.trust}>{t.ptHeroTrust}</p>
      </div>
      <div className="ssi-ptHero__rightA" style={ptHeroStyles.rightA}>
        <img src="/assets/hero_woman_hijab.png?v=6" alt="" style={ptHeroStyles.heroImg}/>
        <div className="ssi-ptHero__bubble" style={ptHeroStyles.bubble} aria-hidden>
          <span style={ptHeroStyles.bubbleWord}>{t.ptHeroBubble || "Olá!"}</span>
          <span style={ptHeroStyles.bubbleTail}/>
        </div>
      </div>
    </section>
  );
}

function PortugueseHeroB({ onStart, t }) {
  return (
    <section className="ssi-ptHero ssi-ptHero--B" style={ptHeroStyles.wrapB}>
      <div className="ssi-ptHero__innerB" style={ptHeroStyles.innerB}>
        <div className="ssi-ptHero__giantWrap" style={ptHeroStyles.giantWrap}>
          <span style={ptHeroStyles.giantTranslate}>(verb) to speak</span>
          <div style={ptHeroStyles.giant} aria-hidden>{t.ptHeroGiantWord}</div>
          <div style={ptHeroStyles.giantUnderline}/>
        </div>
        <div style={ptHeroStyles.copyB}>
          {t.ptHeroKicker && <div style={ptHeroStyles.kickerB}>{t.ptHeroKicker}</div>}
          <h1 style={ptHeroStyles.h1B}>{t.ptHeroTitle}</h1>
          <p style={ptHeroStyles.ledeB}>{t.ptHeroSub1}</p>
          <p style={ptHeroStyles.ledeB}>{t.ptHeroSub2}</p>
          <div style={ptHeroStyles.ctas}>
            <Link to="/pay?course=en-pt" className="btn btn--onDark">{t.ptHeroCta1}</Link>
            <a href="#sample" className="btn" style={ptHeroStyles.ghost}>{t.ptHeroCta2}</a>
          </div>
          <p style={ptHeroStyles.trustB}>{t.ptHeroTrust}</p>
        </div>
      </div>
    </section>
  );
}

const ptHeroStyles = {
  kicker: { fontSize: 12, letterSpacing: '.18em', textTransform: 'uppercase', color: '#FFD8D4', fontWeight: 600, marginBottom: 18 },
  h1: { fontFamily: 'var(--font-display)', fontSize: 64, lineHeight: 1.04, color: '#fff', letterSpacing: '-.015em', margin: '0 0 20px', textWrap: 'balance' },
  lede: { fontSize: 18, lineHeight: 1.55, color: 'rgba(255,255,255,.92)', margin: '0 0 18px', maxWidth: 540 },
  ctas: { display: 'flex', gap: 12, marginTop: 20, marginBottom: 24 },
  ghost: { background: 'transparent', color: '#fff', border: '1px solid rgba(255,255,255,.5)' },
  trust: { fontSize: 13, color: 'rgba(255,255,255,.72)', margin: 0 },
  wrapA: { background: 'var(--brandRed)', color: '#fff', padding: '88px 0 88px', position: 'relative', overflow: 'hidden', minHeight: 560 },
  leftA: { maxWidth: 600, padding: '0 32px', position: 'relative', zIndex: 2 },
  rightA: { position: 'absolute', right: 0, top: 0, bottom: 0, width: '50%', display: 'flex', alignItems: 'flex-end', justifyContent: 'center' },
  heroImg: { width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center bottom' },
  bubble: { position: 'absolute', left: 'calc(10% )', top: 64, background: "#FFD84D", color: '#490300', padding: '18px 28px 22px', borderRadius: 18, transform: 'rotate(-5deg)', boxShadow: '0 18px 40px -14px rgba(0,0,0,.35), 0 2px 0 rgba(0,0,0,.08)', zIndex: 3 },
  bubbleWord: { fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 52, lineHeight: 1, letterSpacing: '-.02em', display: 'inline-block', fontStyle: 'italic' },
  bubbleTail: { position: 'absolute', left: 36, bottom: -12, width: 22, height: 22, background: "#FFD84D", borderBottomLeftRadius: 4, borderStyle: 'solid', borderWidth: '0 0 2px 2px', borderColor: 'transparent', transform: 'rotate(-45deg)' },
  wrapB: { background: 'var(--brandRed)', color: '#fff', padding: '80px 0 88px', position: 'relative', overflow: 'hidden' },
  innerB: { maxWidth: 1240, margin: '0 auto', padding: '0 32px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 56, alignItems: 'center' },
  giantWrap: { position: 'relative' },
  giantTranslate: { display: 'inline-block', fontSize: 13, color: 'rgba(255,255,255,.7)', letterSpacing: '.02em', fontStyle: 'italic', marginBottom: 4, marginLeft: 4 },
  giant: { fontFamily: 'var(--font-display)', fontSize: 'clamp(96px, 13vw, 200px)', lineHeight: .95, fontWeight: 700, letterSpacing: '-.03em', color: '#fff', margin: 0 },
  giantUnderline: { width: 80, height: 4, background: '#FFD84D', borderRadius: 4, marginTop: 20, marginLeft: 4 },
  copyB: { maxWidth: 520 },
  kickerB: { fontSize: 12, letterSpacing: '.18em', textTransform: 'uppercase', color: '#FFD8D4', fontWeight: 600, marginBottom: 16 },
  h1B: { fontFamily: 'var(--font-display)', fontSize: 44, lineHeight: 1.1, color: '#fff', letterSpacing: '-.015em', margin: '0 0 18px', textWrap: 'balance' },
  ledeB: { fontSize: 16.5, lineHeight: 1.55, color: 'rgba(255,255,255,.92)', margin: '0 0 16px', maxWidth: 520 },
  trustB: { fontSize: 13, color: 'rgba(255,255,255,.72)', margin: 0 },
};
